<template>
  <vs-popup class="add-new-incoterms"
            id="popup"
            :title="isCreateMode ? 'ADD CCP ITEM' : 'UPDATE CCP ITEM'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-incoterms-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

         <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="form.description" height="150px"/>
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Type</small>
                <v-select :clearable="true" placeholder="" v-model="form.type"
                          :options="productionCodeTypes" :reduce="option => option.value" label="label"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          @input="onTypeChange">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <vs-checkbox v-model="useProductionCodes" @input="onToggleProductionCodes">Production Code CCP</vs-checkbox>
            </div>
          </div>

          <div class="mb-3 vx-row" v-if="useProductionCodes">
            <div class="w-full vx-col md:w-full md:mb-0">
              <small class="label">Production Codes</small>
              <v-select :clearable="true" multiple placeholder="" v-model="productionCodeIds"
                        :options="productionCodeOptions" :reduce="option => option.id" label="prefix"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'">
              </v-select>
            </div>
          </div>

          <vx-card carBorder noShadow title="Documents">
            <FilePreviewGallery :removable="true" :files="form.file_paths" @remove="removeFile"/>

            <br>

            <multi-file-uploader
              v-on:onSetFileName="onSetFiles($event)"
              :file="''"
              file_path="ccp-item/attachments"
              :condition="true"/>

            
          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const CcpRepository = RepositoryFactory.get('ccp');
  const ProductionCodeRepository = RepositoryFactory.get('production_code');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue"

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        description: '',
        type: '',
        file_paths: []
      },
      useProductionCodes: false,
      productionCodeIds: [],
      productionCodeOptions: [],
      productionCodeTypes: [
        { value: 'Powder',           label: 'Powder' },
        { value: 'Liquid',           label: 'Liquid' },
        { value: 'Spray Dry Powder', label: 'Spray Dry Powder' },
        { value: 'Fruit', label: 'Fruit' },
      ],
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewCcpItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          await this.fetchProductionCodes();
          this.open = true;
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchIncotermDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      onSetFiles(file_path) {
        this.form.file_paths.push(file_path)
      },
      removeFile(index) {
        this.form.file_paths.splice(index, 1);
      },
      async fetchProductionCodes(formulation_type = null) {
        if (!formulation_type) {
          this.productionCodeOptions = []
          return
        }
        const { data } = await ProductionCodeRepository.getFormulationProductionCodesDropdown(formulation_type)
        this.productionCodeOptions = data.data
      },
      async fetchIncotermDetails() {
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          const {data} = (await CcpRepository.getCcp(this.id)).data
          this.form = data
          const productionCodeIds = Array.isArray(data.production_codes) ? data.production_codes.map(c => c.id) : []
          if (productionCodeIds.length > 0) {
            this.useProductionCodes = true
            this.productionCodeIds = productionCodeIds
            const type = data.type || (data.production_codes[0] && data.production_codes[0].formulation_type)
            if (type) {
              this.form.type = type
              await this.fetchProductionCodes(type)
            } else {
              this.productionCodeOptions = data.production_codes
            }
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
      onTypeChange(val) {
        if (this.useProductionCodes) {
          this.productionCodeIds = []
          this.productionCodeOptions = []
          this.fetchProductionCodes(val)
        }
      },
      onToggleProductionCodes(val) {
        this.productionCodeIds = []
        this.productionCodeOptions = []
        if (val && this.form.type) {
          this.fetchProductionCodes(this.form.type)
        }
      },
      async onClickCreateSite() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-incoterms-popup',
          scale: 0.45
        })
        try {
          const { production_codes, ...formData } = this.form;
          const payload = { ...formData, production_code_ids: this.productionCodeIds };
          if (this.isCreateMode) {
            await CcpRepository.createCcp(payload);
            this.showSuccessMessage('CCP item added!');
          } else {
            await CcpRepository.updateCcp(this.id, payload);
            this.showSuccessMessage('CCP item updated!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
      FilePreviewGallery
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-incoterms >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
